import React from "react";
import "./branch.css";

function Branch({ branch }) {
  if (!branch) {
    return null;
  }

  const countryCode = () => {
    if (branch?.country === "India") {
      return "IN";
    } else if (branch?.country === "Australia") {
      return "AU";
    } else if (branch?.country === "Nepal") {
      return "NP";
    }
    return "";
  };

  const branchTitle = () => {
    if (branch?.title === "Jalandhar") {
      return branch?.country + " · Regional HQ";
    } else if (branch?.title === "Parramatta") {
      return branch?.country + " · HQ";
    }
    return branch?.country || "";
  };

  return (
    <div className="la-branch-card">
      <div className="la-branch-head">
        <div className="la-branch-code">{countryCode()}</div>
        <div>
          <h3 className="la-branch-title">{branch?.title}</h3>
          <p className="la-branch-country">{branchTitle()}</p>
        </div>
      </div>

      <hr className="la-branch-divider" />

      <div className="la-branch-address">
        <p>{branch?.address}</p>
      </div>

      {branch?.contact_number_to_display ? (
        <div className="la-branch-contact">
          <span className="la-branch-contact-icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"
                fill="#94C23C"
              />
            </svg>
          </span>
          <a href={"tel:" + (branch?.contact_number_to_dial || "")}>
            {branch?.contact_number_to_display}
          </a>
        </div>
      ) : null}

      {branch?.direction_link ? (
        <div className="la-branch-actions">
          <button
            type="button"
            className="la-branch-direction-btn"
            onClick={() => window.open(branch?.direction_link, "_blank")}
          >
            Directions
            <span className="la-branch-arrow" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7 17L17 7M17 7H8M17 7V16"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default Branch;
